import {
    Checkbox,
    Container,
    FormControlLabel,
    FormGroup,
    Grid
} from "@material-ui/core";
import React from "react";
import "../styles/deckCreationStyles.css";
import "../styles/masterStyles.css";
import { SaspButton } from "./SaspButton";

//TODO create a select all button for questions
export const ChooseQuestionsForm = props => {
    const [checkQuestions, setQuestions] = React.useState(props.questionObj);

    const createMarkup = props => {
        return { __html: props };
    };

    const mapQuestions = props => {
        return Object.keys(props.questions).map((question, index) => {
            return (
                <div className="questionBox">
                    <div
                        dangerouslySetInnerHTML={createMarkup(
                            props.questions[index].questiontext
                        )}
                    ></div>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checkQuestions[question]}
                                onChange={handleChange(props.questions[question].questionID)}
                                value={checkQuestions[question]}
                            />
                        }
                        // label={question.questiontext}
                    />
                </div>
            );
        });
    };

    //TODO refactor to make this actually work properly
    const handleChange = name => event => {
        setQuestions({ ...checkQuestions, [name]: event.target.checked });
    };

    const selectAllQuestions = (data) => {
        try {
            for (const item in data) {
                let name = data[item].questionID;
                setQuestions({ ...checkQuestions, [name]: true});
            }
        } catch (e) {
        }
    }

    if (props.questionCount && props.questionCount > 0) {
        return (
            <Container className="createDeckFormContainer" maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <div className="flex-row-center padding-right-12 hidden" >
                            <div>
                                <FormControlLabel
                                    className="margin-right-0"
                                    control={
                                        <Checkbox
                                            checked={false}
                                            value={1}
                                            onClick={() => selectAllQuestions(props.questions)}
                                        />
                                    }
                                />
                            </div>
                            <div className="text-strong">Select All</div>
                        </div>
                        <FormGroup>
                            <div>{mapQuestions(props)}</div>
                        </FormGroup>
                    </Grid>

                    <SaspButton 
                        className="margin-top-16 text-white"
                        onClick={() => props.createDeck(checkQuestions)}
                    >
                        Create Deck
                    </SaspButton>
                </Grid>
            </Container>
        );
    } else {
        return (
            <div>Sorry, we couldn't find any questions that matched your search.</div>
        );
    }
};

//TODO style this page & user feedback
//TODO add questions/map the data. finish wiring up the service
